export default __webpack_public_path__ + "static/media/marginTaxationIcon.0d5605d3.svg";